<template>
  <div id="container">
    <vs-popup fullscreen title="Manage Master Stock Codes" :active.sync="showAddMasterCode">
      <manageMasterCodes></manageMasterCodes>
    </vs-popup>
    <vs-button @click="$emit('close')" color="primary" type="border" icon-pack="feather"
      icon="icon-arrow-left"></vs-button>
    <div class="vx-row">
      <div class="vx-col w-full md:w-2/3">
        <vx-card title="Add New Item">
          <!-- gs data : {{ getGs }} -->
          <form-wizard color="rgba(var(--vs-primary), 1)" :title="null" :subtitle="null"
            :finishButtonText="finisButtonLabel" @on-complete="formSubmitted">
            <tab-content title="Company & Stock" class="mb-5">
              <vs-divider> </vs-divider>
              <!-- tab 1 content -->
              <div class="vx-row align-center">
                <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
                  <vx-card title="Select Company" class="text-center">
                    <companyRadio v-model="getGs.compId" :defaultValue="getGs.compId" />
                  </vx-card>
                </div>
                <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
                  <vx-card title="Select Stock" class="text-center">
                    <stockRadio v-model="getGs.stock" :defaultValue="getGs.stock" />
                  </vx-card>
                </div>
              </div>
            </tab-content>

            <!-- tab 2 content -->
            <tab-content title="Master Code & Quantity" class="mb-5">
              <div class="vx-row align-center">
                <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
                  <div class="vx-row align-center">
                    <vx-card title="Select Master Stock Code" class="text-center">

                      <masterCodeField v-model="getGs.masterStockCode" />
                    </vx-card>
                    <vx-card v-if="getGs.masterStockCode" title="Select Sub Stock Code" class="text-center">

                      <subStockCodeField v-model="getGs.subStockCode" :masterStockCode="getGs.masterStockCode.id"
                        :key="getGs.masterStockCode.id" />
                    </vx-card>
                  </div>

                </div>
                <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
                  <form>
                    <div class="vx-row">
                      <div class="vx-col w-1/2">
                        <vs-input size="large" v-validate="'max:5|numeric'" label="Quantity To Send" name="qtyToSend"
                          v-model="getGs.qtySentOut" class="mt-5 input-center " max="5" />
                        <span class="text-danger text-sm" v-show="errors.has('qtyToSend')">{{
                          errors.first('qtyToSend')
                        }}</span>
                      </div>

                      <div class="vx-col w-1/2">
                        <vs-input size="large" v-validate="'max:5'" label="Unit" name="unit" v-model="getGs.unit"
                          class="mt-5 input-center " max="5" />
                        <span class="text-danger text-sm" v-show="errors.has('unit')">{{
                          errors.first('unit')
                        }}</span>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </tab-content>

            <!-- tab 3 content -->
            <tab-content title="Step 3" class="mb-5">
              <suppliersForm></suppliersForm>

            </tab-content>
          </form-wizard>
        </vx-card>
      </div>
      <div class="vx-col w-full md:w-1/3 lg:w-1/3 xl:w-1/3 mb-base">
        <vx-card title="Company & Stock" class="mb-5">
          <div class="vx-row">
            <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
              <info label="Company" :value="getGs.compId" />
            </div>
            <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
              <info label="Stock" :value="getGs.stock" />
            </div>
          </div>
        </vx-card>

        <vx-card title="Master Code & Quantity" class="mb-5">
          <div class="vx-row">
            <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
              <info v-if="getGs.masterStockCode" label="Master Stock Code" :value="getGs.masterStockCode.label" />
              <info v-if="getGs.subStockCode" label="Sub Stock Code" :value="getGs.subStockCode.label" />
            </div>
            <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
              <info v-if="getGs.qtySentOut" label="Quantity To Send" :value="getGs.qtySentOut" />
              <info v-if="getGs.unit" label="Unit" :value="getGs.unit" />
              <info v-if="getGs.stockBalance" label="Stock Balance" :value="getGs.stockBalance" />
            </div>
            <div v-if="invetoryData" class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
              <info v-if="invetoryData.lineDescription" label="Line Description" :value="invetoryData.lineDescription" />
              <info v-if="invetoryData.sizeDimension" label="Size / Dimension" :value="invetoryData.sizeDimension" />
              <info v-if="invetoryData.thickness" label="Thickness" :value="invetoryData.thickness" />
            </div>
          </div>
        </vx-card>
        <vx-card title="Customer & Others">
          <div class="vx-row">
            <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
              <info v-if="getGs.supplier" label="Customer" :value="getGs.supplier.label" />
              <info v-if="getGs.supplierDocNumber" label="SQL Doc No." :value="getGs.supplierDocNumber" />
            </div>
            <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
              <info v-if="getGs.others" label="Others" :value="getGs.others.label" />
              <info v-if="getGs.remarks" label="Remarks" :value="getGs.remarks" />
            </div>
          </div>
        </vx-card>

      </div>
    </div>
  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import companyRadio from './companyRadio.vue';
import stockRadio from './stockRadio.vue';
import masterCodeField from './masterCodeField.vue';
import subStockCodeField from './subStockCodeField.vue';
import manageMasterCodes from './manageMasterCodes.vue';
import suppliersForm from './suppliersForm.vue';
import info from "@/views/inventory/info.vue";
import { mapGetters } from "vuex";
import { alertMixin } from "@/mixin/alertMixin";
import { axiosMixin } from "@/mixin/axiosMixin.js";
export default {
  mixins: [axiosMixin, alertMixin],
  components: {
    FormWizard,
    TabContent,
    companyRadio,
    stockRadio,
    info,
    masterCodeField,
    subStockCodeField,
    manageMasterCodes,
    suppliersForm,

  },
  data() {
    return {
      showAddMasterCode: false,
      endPoint: "goodsentouts",
      operation: "add",
      finalValues: {},
      origValue: {},
    }
  },
  methods: {
    startLoading() {
      this.disableSubmitBtn = false;
      this.$vs.loading({
        container: "#container",
        scale: 0.6
      });
    },
    stopLoading() {
      this.disableSubmitBtn = true;
      this.$vs.loading.close("#container > .con-vs-loading");
    },

    //checkIfStockBalanceIsEnought
    formSubmitted() {
      this.startLoading();

      let params = {
        masterStockCode: this.getGs.masterStockCode.id,
        subStockCode: this.getGs.subStockCode.id,
        qtySentOut: this.getGs.qtySentOut,
        itemId: this.getGs.id,
      };

      this.aronPost(
        'checkIfStockBalanceIsEnought',
        params,
        '', ''
      )
        .then(response => {
          console.log('response:', response)
          if (response.data.code == 200) {
            this.stopLoading();
            this.finalSubmittion();
          }

          this.stopLoading();
        })
        .catch(error => {
          this.stopLoading();
          this.decodeErrorFromAxios(error).then((errorMsg) => {

          });
        }); // end of aronPostPut
    },
    finalSubmittion() {
      this.startLoading();

      this.origValue = JSON.parse(JSON.stringify(this.getGs));

      this.finalValues = this.getGs;
      this.finalValues.masterStockCode = this.getGs.masterStockCode.id;
      this.finalValues.subStockCode = this.getGs.subStockCode.id;
      this.finalValues.supplier = this.getGs && this.getGs.supplier && this.getGs.supplier.id
        ? this.getGs.supplier.id
        : '';

      this.finalValues.others = this.getGs && this.getGs.others && this.getGs.others.id
        ? this.getGs.others.id
        : '';
      this.finalValues.gsNumber = this.$store.state.main.currentGsNumber;

      this.aronPostPut(
        this.endPoint,
        this.$store.state.main.gsCurrentItemOperation,
        this.finalValues,
        this.getGs.id
      )
        .then(response => {
          console.log("final:", response);
          if (this.$store.state.main.gsCurrentOperation == "add") {

            this.origValue.gsNumber = response.data.gsNumber;
            this.$store.state.main.currentGsNumber = response.data.gsNumber;
            this.$store.state.main.gsCurrentOperation = 'update';
            this.origValue.lineDescription = response.data.lineDescription;
            this.origValue.sizeDimension = response.data.sizeDimension;
            this.origValue.thickness = response.data.thickness;

          } else {
            this.origValue.gsNumber = response.data.gsNumber;
            this.$emit("updateRow", {
              response: response.data,
              view: "view"
            });
          }

          this.origValue.id = response.data.id;

          this.origValue.status = response.data.status;
          this.origValue.itemNumber = response.data.itemNumber;
          this.origValue.supplier = response.data.supplier;
          this.origValue.others = response.data.others;

          //add to addItemToGrGroup action store

          if (this.$store.state.main.gsCurrentItemOperation == "add") {
            this.$store.dispatch("main/addItemToGsGroup", this.origValue);
          } else {
            this.$store.dispatch("main/updateGSGroupData", this.origValue);
          }


          //emit close
          this.$emit("close");

          this.stopLoading();
        })
        .catch(error => {
          console.error("error from : update profile_edit. reason:", error);
          this.stopLoading();
        }); // end of aronPostPut
    },
  },
  computed: {
    ...mapGetters({
      getGs: "main/getGs",
      invetoryData: "main/invetoryData"
    }),
    finisButtonLabel() {
      if (this.$store.state.main.gsCurrentItemOperation == "add") {
        return "Add GS";
      } else {
        return "Update GS";
      }
    },
  }
};
</script>
<style>
.input-center {
  text-align: center;
}

.input-center input {
  text-align: center;
}
</style>
